export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/sparkles-icon.png?49cadd4e938a9087967339b7ca97d9d5";